import * as React from "react";
import { makeStyles, Text } from "@fluentui/react-components";
import { CARD_TYPES } from "../../../shared/constants";
import SummaryCard from "./SummaryCard";
import ActionItemsCard from "./ActionItemsCard";
import DraftReplyCard from "./DraftReplyCard";
import TranslationCard from "./TranslationCard";
import RephraseCard from "./RephraseCard";
import ComposeCard from "./ComposeCard";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "0 16px 16px",
  },
  fallback: {
    padding: "16px",
    backgroundColor: "var(--bg-elevated, #FFFFFF)",
    border: "1px solid var(--border-primary, #E0E2E6)",
    borderRadius: "12px",
    boxShadow: "var(--shadow-sm, 0 1px 2px rgba(11,17,26,0.06))",
  },
  fallbackTitle: {
    color: "var(--text-secondary, #4A4F57)",
    fontSize: "13px",
  },
});

/**
 * Routes each card object to the correct card component based on card.type.
 *
 * @param {{
 *   cards: Array<Object>,
 *   onExecuteAction: Function,
 *   actionStates: Object,
 *   emailContext: Object,
 * }} props
 */
const CardRouter = ({ cards = [], onExecuteAction, actionStates = {}, emailContext }) => {
  const styles = useStyles();

  if (!cards || cards.length === 0) return null;

  const renderCard = (card, index) => {
    const key = card.id || `${card.type}-${index}`;

    switch (card.type) {
      case CARD_TYPES.SUMMARY:
        return <SummaryCard key={key} card={card} />;

      case CARD_TYPES.ACTION_ITEMS:
        return (
          <ActionItemsCard
            key={key}
            card={card}
            onExecuteAction={onExecuteAction}
            actionStates={actionStates}
            emailContext={emailContext}
          />
        );

      case CARD_TYPES.DRAFT_REPLY:
        return <DraftReplyCard key={key} card={card} />;

      case CARD_TYPES.TRANSLATION:
        return <TranslationCard key={key} card={card} />;

      case CARD_TYPES.REPHRASE:
        return <RephraseCard key={key} card={card} />;

      case CARD_TYPES.COMPOSE:
        return <ComposeCard key={key} card={card} />;

      default:
        return (
          <div key={key} className={styles.fallback}>
            <Text className={styles.fallbackTitle}>
              Unsupported card type: {card.type || "unknown"}
            </Text>
            {card.body_markdown && (
              <Text size={200} style={{ color: "var(--text-tertiary, #6E747D)", marginTop: "8px", display: "block" }}>
                {card.body_markdown}
              </Text>
            )}
          </div>
        );
    }
  };

  return <div className={styles.container}>{cards.map(renderCard)}</div>;
};

export default CardRouter;
